<template>
<div id="app">
  <div class="banner"><img src="./img/banner.png" alt=""></div>
  <div class="aboutus">
    <el-tabs tab-position="left" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="关于我们" name="about">
        <div class="aboutbox">
          <h2>关于我们</h2>
          <p>大救星全球综合救援智能云平台由江泰救援服务有限公司自主研发并运营，在传统医疗救援的基础上，为全球用户提供了涵盖救援、救治、救助、救护的“四救十六助”综合服务，并衍生51大类服务内容。</p>
          <p>高品质的服务能力源自大救星庞大的全球救援服务网络。大救星平台是自建全球服务网络的中资救援服务平台，组建10个工作组历时三年时间、走访100多个国家和地区，搭建包含救援公司、安保公司、律师事务所、华人旅行社等机构在内的服务商网络，以及能够熟练使用中文及当地语言、可随时随地提供全球救助服务的华人星使服务网络。救援服务覆盖全球（含战乱及受经济制裁国家和地区）、星使服务网络覆盖138个国家和地区、820多个重点城市！每年服务人次超过5000万。</p>
           <p>基于移动互联网技术，大救星平台以线上和线下结合的方式，用共享经济模式为出境的中国公民及入境的外国友人提供及时、高效的救援和救助服务。大救星平台是政府救援的重要补充，是商业救援的创新模式，构建了中国公民/海外公民、境内外救援救助机构以及个体服务者“星使”之间的服务生态圈，为用户在旅行、生活、商务、留学、劳务、探亲等情境下带来全方位安全保障。</p>
          <p style="color:#00ABFA;">大救星24小时全球救援电话 +86-10-83423665</p>
          <div style="height: 40px"></div>
          <h2>服务亮点</h2>
          <h4>一键救援</h4>
          <p>
            大救星独创的“一键救援”功能，是互联网科技与传统救援模式的完美结合。“一键救援”功能的优势，在于对传统救援报案流程的简化。用户无需记录或存储救援电话，当遭遇险情时，可通过点击大救星手机APP或微信小程序首页的“一键救援”按键，并等待倒计时5秒，系统会自动将用户当前GPS定位及个人信息上报救援指挥中心完成呼救。如遭遇网络较差等特殊情况，“一键救援”可自动切换为电话呼救，帮助用户直接拨打大救星救援服务热线。“一键救援”适用于所有用户，无论身处任何国家、任何地方，无论用户是否购买大救星救援保障服务，只要发起呼救，大救星便会第一时间进行响应。
            <img src="./img/yijianjiuyuan.png" alt="" style="width:100%">
          </p>
          <h4>24h服务</h4>
          <p>大救星设有24小时待命的全球救援指挥中心，在收到用户呼救后的60秒内，将以人工电话回拨的方式与用户进一步联系、核实、确认，并在第一时间采取应急预案，实施全球救援。</p>
          <h4>全球救援</h4>
          <p>大救星依靠丰富的全球救援服务网络，在全球233个国家（含战乱、制裁国家和地区）拥有签约服务商1000余家，下设服务网点60余万个。可为用户提供包括紧急医疗转运、医疗送返、照顾未成年子女、安排亲友探访、医疗陪同服务、报案陪同服务、补办证件陪同服务、遗体送返或火化、电话医生（或视频问诊）等救援服务；以及覆盖医疗健康、商务法律、生活娱乐等领域的安全管家服务。</p>
          <h4>双语星使</h4>
          <p>大救星在全球138个国家招募有3000余名星使，他们是在当地生活、工作的华人，精通双语且熟悉所处地人文环境。所有星使皆通过了大救星实名认证，能够为用户提供安全、有效的线上咨询、线下陪同、代办代理等服务。大救星会定期对星使组织有针对性的线上培训，持续提升星使服务能力。</p>
          <h4>风险预警</h4>
          <p>大救星APP为所有用户免费提供实时的全球风险预警服务，预警内容包含暴乱、游行、踩踏、爆炸、台风、污染等50种常见危险信号，为用户出行提供24小时的安全参考。此外大救星APP中的自救手册还包含突发症状、意外伤害、社会治安、自然灾害四类，共百余种常见危急场景，为用户提供简单易学的预防及应对方案。</p>
        </div>
      </el-tab-pane>
      <el-tab-pane label="新闻中心" name="news">
        <div class="newsbox">
          <h2>新闻中心</h2>
          <div v-if="!detail">
            <dl @click="goNewsDetail(item)" v-for="(item,index) in newsList" :key="index">
              <dt><img :src="item.pic?item.pic:require('./img/default.jpg')" alt=""></dt>
              <dd>
                <h6><span>{{item.title}}</span>
                  <!-- <i>{{format(item.updateAt)}}</i> -->
                  <i>{{item.createAt}}</i>
                </h6>
                <p>{{item.dissect}}</p>
                <!-- <span></span> -->
              </dd>
            </dl>
            <el-pagination
              background
              layout="total, prev, pager, next"
              @current-change="handleCurrentChangeNews"
              @prev-click="newsPrev"
              :page-size="10"
              :total="newspageTotal">
            </el-pagination>
          </div>
          <Aboutdetail v-else :id='id'></Aboutdetail>
        </div>
      </el-tab-pane>
      <el-tab-pane label="江泰全球救援联盟">
        <div class="jylmbox">
          <h4>江泰全球救援联盟是江泰救援服务有限公司于2016年3月20日发起创立的，由来自世界各地的独立救援公司、包机公司、安保公司、律师事务所、旅行社、医疗机构、相关中介服务机构等自愿参与并组成的全球性救援服务组织。旨在拓展全球救援行业体系，为联盟成员之间合作共享搭建桥梁。联盟目前已拥有超过200家成员机构，所构建的救援服务网络覆盖全球，含战乱及受经济制裁的国家和地区。</h4>
          <h3>秉持“共享和共赢”宗旨，联盟通过共享经济模式，为每一个成员提供如下便利和利益：</h3>
          <ol>
            <li><img src="./img/1_list.png" alt="">融入到中国大发展的洪流中，分享中国发展的红利。</li>
            <li><img src="./img/2_list.png" alt="">为中国公民、中国企业在当地提供商业化救援服务，获得增收新商机。</li>
            <li><img src="./img/3_list.png" alt="">扩大服务范围以及覆盖国家和地区，提高自身竞争力，吸引更多客户。</li>
            <li><img src="./img/4_list.png" alt="">形成发展平台，救援联盟成员之间互相委托创造更多利益。</li>
            <li><img src="./img/5_list.png" alt="">联盟成员通过举行会议等形式实现信息共享，资源共享。</li>
          </ol>
          <button @click="submitAiderDialog=true">立即加入全球救援</button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="星使服务">
        <div class="xingshibox">
          <h2>星使服务</h2>
          <h4>星使服务是由江泰救援自研自建的本地服务，我们拥有完整的服务模式和星使培训体系，截至目前已经有近三千多名熟悉本地服务的星使分布在全球各地，为国人提供当地救援、救助、陪同、向导、翻译、法律援助、住院安排、医疗就诊、转运等线上线下服务。依托于江泰救援平台，星使可以自行设定服务项目，自动接收来自国人的有酬求助、陪同邀请等。服务亿万国人的同时，还能赚取一笔收益，快来加入星使团队吧。</h4>
          <h2>如何成为星使？</h2>
          <p v-if="false"><img src="./img/ticon.png" alt="">下载大救星</p>
          <p  v-if="false" style="font-weight:normal;margin-left: 1.302083vw">Android手机：国内手机从各大应用市场如360手机助手等应用下载，国外手机从Googleplay下载<br>
苹果手机：从AppStore下载；</p>
          <p><img src="./img/ticon.png" alt="">要成为星使，需要进行以下4步操作</p>
          <img src="./img/iPhone.png" alt="" style="margin-top: 1.5625vw;width: 100%">
        </div>
      </el-tab-pane>
      <el-tab-pane label="服务案例" name="case">
        <div class="newsbox">
          <h2>服务案例</h2>
          <div v-if="!isCaseDetail">
            <dl  @click="goCaseDetail(item)" v-for="(item,index) in caseList" :key="index">
              <dt><img :src="item.pic?item.pic:require('./img/default.jpg')" alt=""></dt>
              <dd>
                <h6><span>{{item.title}}</span>
                  <!-- <i>{{format(item.updateAt)}}</i> -->
                  <i>{{item.createAt}}</i>
                </h6>
                <p>{{item.dissect}}</p>
              </dd>
            </dl>
            <div style="margin: 0 auto"> 
              <el-pagination
            background
            layout="total, prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="10"
            :total="pageTotal">
          </el-pagination>
            </div>
          
          </div>
          <Aboutdetail v-else :id='id'></Aboutdetail>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
  <el-dialog :visible.sync="submitAiderDialog" class="modal">
    
      <h2>服务商加盟</h2>
      <form>
        <label for="name">
            <span>
                <small>公司名称:</small>
                <small>Company name</small>
            </span>
            <input type="text" name="" id="name" placeholder="请输入公司名称">
        </label>
        <label for="type">
            <span>
                <small>服务类型:</small>
                <small>Service type</small>
            </span>
            <input type="text" name="" id="type" placeholder="请输入公司服务类型">
        </label>
        <label for="Country">
            <span>
                <small>国家:</small>
                <small>Country</small>
            </span>
            <input type="text" name="" id="Country" placeholder="请输入公司所服务的国家">
        </label>
        <label for="Contact">
            <span>
                <small>联系人姓名:</small>
                <small>Contact name</small>
            </span>
            <input type="text" name="" id="Contact" placeholder="请输入公司联系人">
        </label>
        <label for="Tel">
            <span>
                <small>电话:</small>
                <small>Tel</small>
            </span>
            <input type="text" name="" id="Tel" placeholder="请输入联系人电话">
        </label>
        <label for="Email">
            <span>
                <small>邮箱:</small>
                <small>Company name</small>
            </span>
            <input type="text" name="" id="Email" placeholder="请输入公司邮箱">
        </label>
        <label for="Message">
            <span>
                <small>信息:</small>
                <small>Message</small>
            </span>
            <input type="text" name="" id="Message" placeholder="请输入详细信息">
        </label>
      </form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitAiderDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitAiderDialog = false;submit()">确 定</el-button>
      </div>
  </el-dialog>
</div>
</template>

<script>
import util from '@/util/util.js'
import Axios from 'axios'
import Aboutdetail from '@/views/aboutus/aboutdetail'
export default {
  components:{
    Aboutdetail
  },
  data () {
    return {
        newsList: '',
        caseList: '',
        detail:false,
        isCaseDetail: false,
        id:'',
        activeName: 'about',
        submitAiderDialog: false,
        api: util.config.api,
        start: '',
        // currentPage: '1',
        count: '10',
        // pageSize: '10',
        pageTotal: null,
        newspageTotal: null
    };
  },
  beforeDestroy () {
    // 组件销毁之前,解除所有绑定
    this.$root.bus.$off('about')
    this.$root.bus.$off('back')
  },
  created(){
    let that = this
    if (this.$route.query.activeName) this.activeName = this.$route.query.activeName;
    that.$root.bus.$on('about', value => {
      that.activeName = value;
    })
    that.$root.bus.$on('back', value => {  //back只是一个起到传true和false的作用
      that.isCaseDetail = value;
      that.detail = value;
    })
    // console.log(this.$route.query.activeName)
    // this.activeName = this.$route.query.activeName;
    if (this.$route.query.id) {
      // this.detail = true;
      if(this.$route.query.activeName == 'news'){
        this.detail = true;
        this.isCaseDetail = false;
      }else{
        this.isCaseDetail = true;
        this.detail = false;
      }
      this.id = this.$route.query.id
    }
    this.getNewsList();
    this.geCaseList();
  },
  methods: {
    // getNewsList(){
    //   Axios({
    //     params:{
    //       category:'1',
    //       start: this.start,
    //       count:'10'
    //     },
    //     methods:'post',
    //     baseURL: this.api,
    //     url: '/1.0/portal/portalNews'
    //   }).then(res=>{
    //     this.newsList = res.data.obj;
    //     this.newspageTotal = res.data.total;
    //   }).catch(error=>{
    //     console.log(error)
    //   })
    // },
    getNewsList() {
        Axios({
          params: {
            category: '1', //1 资讯
            start: this.start,
            type:'12',
            count: '10'
          },
          methods: 'post',
          baseURL:this.api,
          url: '/1.0/news/news-list'
        }).then(res => {
          // console.log(res,'首页资讯');
          this.newsList = res.data.obj;
          this.newspageTotal = res.data.total
        }).catch(error => {
          console.log(error)
        })
      },
    geCaseList(){
      Axios({
        params:{
          category:'2',
          start: this.start,
          type:'11',
          count:'10'
        },
        methods:'post',
        baseURL: this.api,
        url: '/1.0/news/news-list'
      }).then(res=>{
        console.log(res,'关于我们服务案例')
        this.caseList = res.data.obj;
        this.pageTotal = res.data.total;
      }).catch(error=>{
        console.log(error)
      })
    },
    handleCurrentChange: function(currentPage,type){
      // this.currentPage = currentPage;
      this.start = (currentPage-1)*this.count;

      this.geCaseList();
      console.log(this.type)  //点击第几页
    },
    handleCurrentChangeNews: function(currentPage){
      this.start = (currentPage-1)*this.count;
      this.getNewsList();
    },
    newsPrev: function(currentPage){
      console.log(currentPage)
    },
    goNewsDetail(item){
      this.id = item.id;
      if(item.attribute == 4) {
        window.open(item.url)
      }else {
        this.detail = true;
      }
     
   
    },
    goCaseDetail(item){
      this.id = item.id;
      if(item.attribute == 4) {
        window.open(item.url)
      }else {
        this.isCaseDetail = true;
      }
   
     
      // 此方法同上作用相同 that.$root.bus.$emit('back', true)
    },
    handleClick(tab, event) {
      if(tab.name=="news"){
        this.detail = false;
        
      }else if(tab.name=="case"){
        this.isCaseDetail = false;
      }
      // console.log(tab, event);
    },
    // goCaseDetail(id){
    //   this.id = id;
    //   this.isCaseDetail = true;
    // },
    submit(){
      this.$message({
        message: '您已成功提交信息',
        type: 'success'
      });
      // Message.success("您已成功提交信息");
    },
    format(timestamp){
      var date = new Date(timestamp);
      let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    }
  }
}
</script>
<style lang="scss">
#app{
  .el-pagination{
    padding-left: 18vw;
  }
}
.banner{
  width: 100%;
  img{
    width: 100%;
  }
}
  .aboutus{
    background: #fff;
    padding-top: 3.645833vw;
    padding-bottom: 2.604166vw;
    .el-tabs{
      padding: 0 17vw;
      /*width: 1191px;
      margin: 0 auto;*/
      .el-tabs__nav-wrap{
        width: 11.71875vw;
        background: #B1E6FF;
        border: 1px solid #99DDFD;
        padding-top: .520833vw;
      }
      .el-tabs__item{
        text-align: center!important;
        line-height: 3.125vw;
        background: #fff;
        color: #333;
        font-size:1.0412vw;
        height: 3.125vw;
      }
      .el-tabs__item.is-active{
        background: #00ABFA;
        color: #fff;
      }
      .el-tabs__item{
        padding: 0;
      }
      h2{
          font-weight: normal;
          font-size: 1.5625vw;
          margin-bottom: 1.5625vw;
        }
      .aboutbox{
        p{
          color: #333;
          font-size: 1.0412vw;
          margin-bottom: 1.5625vw;
          line-height: 1.5625vw;
          span{
            display: block;
          }
        }
        h4{
          font-weight: normal;
          margin-bottom: 20px;
          font-size: 22px;
          border-bottom: 4px solid #00ABFA;
          width: fit-content;
        }
      }
      .newsbox{
        dl{
          overflow: hidden;
          display: flex;
          margin-bottom: 2.604166vw;
          dt{
            width: 11.25vw;
            height: 9.375vw;
            flex-shrink: 0;
            margin-right: 1.25vw;
            img{
              width: 100%;
              height: 100%;
            }
          }
          dd{
            width: 37.8vw;
            flex-shrink: 0;
            h6{
              padding: .8vw 0;
              span{
                font-size: 1.0412vw;
                color: #333;
                font-weight: normal;
                display: inline-block;
                width: 29vw;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
              }
              
              i{
                float: right;
                color: #888;
                padding-top: .520833vw;
                font-weight: normal;
                font-size: .8333vw;
                line-height: 0.41666vw;
                font-style: normal;;
              }
            }
            p{
              font-size: .8854vw;
              color: #666;
              line-height: 1.875vw;
              // height: 4.2708vw;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              // position: relative;
              // &:after{
              //   content: '...';
              //   background: #fff;
              //   position: absolute;
              //   right: 0;
              //   bottom: 0;
              //   padding-left: .520833vw;
              // }
            }
            
          }
        }
      }
      .jylmbox{
        h4{
          color: #666;
          font-size: 1.145833vw;
          font-weight: normal;
          line-height: 2.083333vw;
        }
        h3{
          color: #333;
          font-size: 1.3541666vw;
          padding: 2.604166vw 0;
          font-weight: normal;
        }
        ol{
          li{
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            font-size: 1.145833vw;
            color: #333;
            line-height: 3.125vw;
            img{
              margin-right: .8vw;
            }
          }
        }
        button{
          width: 18.75vw;
          height: 3.4375vw;
          border: 0;
          border-radius: 4px;
          background: #00abfa;
          color: #fff;
          margin-top: 2.8645833vw;
          font-size: 1.25vw;
          margin-left: 5.20833vw;
        }
      }
      .xingshibox{
        h4{
          color: #666666;
          font-size: 1.0412vw;
          font-family:Microsoft YaHei;
          font-weight: normal;
          margin-bottom: 1.5625vw;
          line-height: 1.8vw;
        }
        p{
          font-size:1.0412vw;
          color: #666;
          font-weight: bold;
          margin-top: 1.302083vw;
          img{
            margin-right: .520833vw;
          }
        }
        p{

        }
      }
    }
    .el-tabs--left .el-tabs__nav-wrap.is-left::after, .el-tabs--left .el-tabs__nav-wrap.is-right::after, .el-tabs--right .el-tabs__nav-wrap.is-left::after, .el-tabs--right .el-tabs__nav-wrap.is-right::after{
      width: 0;
    }
    .el-tabs--left .el-tabs__active-bar.is-left, .el-tabs--left .el-tabs__active-bar.is-right, .el-tabs--right .el-tabs__active-bar.is-left, .el-tabs--right .el-tabs__active-bar.is-right{
      width: 0;
    }
    .el-tabs--left .el-tabs__header.is-left{
      margin-right: 3.0208333vw;
    }
  }
.modal {
  // position: absolute;
  // top: 50%;
  // margin-top: -21.25vw;
  // left: 50%;
  // margin-left: -28.125vw;
  // background: #fff;
  // width: 56.25vw;
  // height: 42.5vw;
  // z-index: 998;
  // border-radius: 0.3125vw;
  // border: 0.0625vw solid #d9ddde;
  h2 {
    width: 100%;
    text-align: center;
    margin-top: 0.625vw;
    line-height: 3.125vw;
    font-size: 1.25vw;
    color: #333;
  }
  form {
    width: 100%;
    padding: 1vw 5vw 2vw;
    box-sizing: border-box;
    label {
      display: block;
      width: 100%;
      height: 2.8125vw;
      margin-top: 1.875vw;
      &:first-child {
        margin-top: 0;
      }
      span {
        float: left;
        width: 11.25vw;
        small {
          display: inline-block;
          width: 100%;
          &:first-child {
            font-size: 1vw;
            color: #303030;
          }
          &:last-child {
            font-size: 0.875vw;
            color: #777;
          }
        }
      }
      input {
        float: left;
        height: 2.8125vw;
        width: 25.125vw;
        border: 0;
        border-radius: 0.3125vw;
        border: 0.0625vw solid #ccc;
        padding-left: 0.9vw;
      }
    }
  }
}
.modal > p {
  width: 100%;
  text-align: center;
}
.modal > p button {
  width: 17.5vw;
  height: 3.125vw;
  border: 0;
  border-radius: 0.25vw;
  background: #00abfa;
  font-size: 1.3125vw;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/aboutus/aboutus.vue